import * as React from "react"

import { cn } from "@/common/lib/utils"

function Input({ className, type, hasError, ...props }: React.ComponentProps<"input"> & { hasError?: boolean }) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-mb-grey-500 hover:border-mb-primary-300 selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border-2 bg-transparent px-3 py-1 text-lg shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:opacity-50 md:text-base dark:text-white dark:placeholder:text-white/50",
        "focus-visible:border-transparent focus-visible:bg-mb-neutral-1 dark:focus-visible:bg-[#3a3a3a]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        hasError && "border-destructive pr-10 placeholder:text-destructive",
        "min-h-[54px]",
        className,
        "o-input",
      )}
      {...props}
    />
  )
}

export { Input }
